import { Box } from '@alf/uikit';
import EventComments from '../../../../EventComments';
import EventFavoriteStar from '../../../../EventFavoriteStar';
import EventHead from '../../../../EventHead';
import { EventIcons } from '../../../../EventIcons';
import EventLinePosition from '../../../../EventLinePosition';
import { EventSubRowButton } from './components/EventSubRowButton';
import MarketCount from './components/MarketCount';

import styles from './index.module.css';

export const EventBodyButton = ({
  lineView,
  eventId,
  lineKey,
  isLiveEvents,
  isDesktop,
  isShowStatUrl,
  classNames,
  increasedOdds,
  headGroups,
  isDisplayHeadMarkets,
  isShowEventGroup
}) => (
  <Box direction="column" flex="1 1 100%" className={styles.container}>
    <Box flex="1 0 auto" direction="row" className={styles.headContainer}>
      <EventLinePosition eventId={eventId} lineView={lineView} />
      <EventHead
        lineView={lineView}
        isShowEventGroup={isShowEventGroup}
        eventId={eventId}
      />
      <EventIcons
        eventId={eventId}
        isShowFavorite={!isDesktop}
        classNames={classNames}
        isShowStatUrl={isShowStatUrl}
        isIconsClickable={isDesktop}
        isHideUnselectedFavorite={true}
        isLiveEvents={isLiveEvents}
        amplitudeEntryPoint="line"
      />
      <EventComments
        eventId={eventId}
        classNames={{
          commentsContainerClass: styles.commentsContainer
        }}
        options={{ overflow: 'ellipsis' }}
      />
    </Box>
    <Box align="center" flex="1 1 100%">
      {isDesktop && (
        <EventFavoriteStar eventId={eventId} className={styles.favorite} />
      )}
      <Box flex="1 1 100%" className={styles.eventSubRowContainer}>
        <EventSubRowButton
          eventId={eventId}
          lineKey={lineKey}
          isActiveLink={true}
          headGroups={headGroups}
          isDisplayHeadMarkets={isDisplayHeadMarkets}
          amplitudeEntryPoint="line"
          increasedOdds={increasedOdds}
        />
      </Box>
      <MarketCount
        lineView={lineView}
        eventId={eventId}
        wrapperProps={{ flex: '0 0 55px' }}
      />
    </Box>
  </Box>
);
